<template>
  <UIDrawer
    :title
    :is-open
    :z-index
    :allow-tray
    @minimize="handleMinimize"
    @close="handleClose"
  >
    <TransactionForm
      v-bind="$attrs"
      :instance="modal.entity"
      @close="handleClose"
    />
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { TransactionClass } from '..'
import { ModalClass } from '@types'

import {
  TRANSACTION_MODAL_TITLE,
  TRANSACTION_MODAL_TITLE_NEW,
} from './utils/const'

import { UIDrawer } from '@ui/modals'
import TransactionForm from './TransactionForm.vue'

type Props = {
  modal: ModalClass<TransactionClass>
  title?: string
}

const props = defineProps<Props>()

const title = computed(
  () =>
    props.title ||
    (props.modal.entity.isNew
      ? TRANSACTION_MODAL_TITLE_NEW
      : TRANSACTION_MODAL_TITLE),
)

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)
const allowTray = computed(() => props.modal.allowTray)

const handleMinimize = () => {
  props.modal.hide()
}

const handleClose = () => {
  props.modal.conditionalClose()
}
</script>
